'use strict'

import axios from 'axios'

const { VUE_APP_COMMS_URL } = process.env

export default async ({ jwt, bodyObject }) => axios({
  method: 'post',
  headers: {
    Authorization: jwt
  },
  url: `${VUE_APP_COMMS_URL}/webform/feedback`,
  data: bodyObject,
  timeout: 8000
})
